import React from 'react';

import { GraphIcon } from '@primer/octicons-react';
import { StyledOcticon } from '@primer/react';

import ErrorLabel from '../common/Labels/ErrorLabel';

export const ChartEmptyState = ({ message }) => (
  <>
    <StyledOcticon
      className="mb-2 text-brand"
      icon={GraphIcon}
      size={64}
    />
    <ErrorLabel className="text-center" size="xl">
      {message || 'Nothing to show right now...'}
    </ErrorLabel>
  </>
)

export default ChartEmptyState;
